import { render, staticRenderFns } from "./DashboardBarChart.vue?vue&type=template&id=26e27274&"
import script from "./DashboardBarChart.vue?vue&type=script&lang=js&"
export * from "./DashboardBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports